import { useQuery, useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../axios/axiosInstance";

export default function useListSearchCriteria(enabled = true) {
  const queryClient = useQueryClient();

  const fetchSearchCriteria = async () => {
    const { data } = await axiosInstance.get("/api/UserSearchCriteria");
    return data;
  };

  const deleteSearchCriteria = async (id: number) => {
    await axiosInstance.put(`/api/UserSearchCriteria/DeleteSearchCriteria?id=${id}`);
  };

  const listQuery = useQuery("ListSearchCriteria", fetchSearchCriteria, {
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    cacheTime: 1000 * 60 * 30,
    staleTime: 1000 * 60 * 5,
  });

  const deleteMutation = useMutation(deleteSearchCriteria, {
    onSuccess: (_data, id: number) => {
      // Refresh the search criteria list
      queryClient.invalidateQueries("ListSearchCriteria");

      // Prevent refetching offers for the deleted subscription id
      const key = ["offers", String(id)];
      // Cancel any in-flight queries for this key
      queryClient.cancelQueries(key, { exact: true });
      // Remove the cached query to stop subsequent refetches
      queryClient.removeQueries(key, { exact: true });
    },
  });

  return { ...listQuery, deleteSearchCriteria: deleteMutation.mutate };
}

